module.exports = __webpack_public_path__ + "img/next-2.f4168c3f.png";